<div class="card dialog-box">
  <div style="max-height: 100%">
    <div class="card-header">
      {{ editSite ? "Edit Site Details" : "Create New Site" }}
      <span class="float-end" (click)="onCloseDialogue()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      @if (editSite) {
        <form [formGroup]="siteForm">
          @if (editSiteName) {
            <div class="form-floating mb-2">
              <input
                class="form-control"
                formControlName="company_name"
                type="text"
                placeholder="Site Name"
                id="siteName"
              />
              <label for="siteName">Site Name</label>
            </div>
          } @else {
            <gtapp-address-lookup
              [addressForm]="siteForm"
              [editSelectedAddress]="true"
            >
            </gtapp-address-lookup>
          }
          <div class="row row-cols-2 mt-2">
            <div class="col">
              <button
                class="btn btn-dark btn-lg btn-block w-100"
                (click)="onCloseDialogue()"
              >
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                [disabled]="!siteForm.valid"
                id="submitbtn"
                (click)="updateData()"
                class="btn btn-primary btn-lg w-100"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      } @else {
        <!-- Forms for Site Details -->

        <form [formGroup]="siteForm">
          <!-- Stepper 1 -->
          <div class="row row-cols-1">
            <gtapp-input-field
              dtValue="Site Name*"
              inputId="siteInputField"
              [maxLength]="256"
              [inputStringValue]="siteForm.value.company_name"
              (blurEmit)="
                siteForm.controls['company_name'].setValue($event);
                checkSiteExists()
              "
            >
            </gtapp-input-field>
            <gtapp-address-lookup
              [addressForm]="siteForm"
              placeholder="Address*"
              (updateAddress)="onAddressSelect()"
            >
            </gtapp-address-lookup>

            @if (!addSiteFormData?.client.data?.primeContractor) {
              @if (addSiteFormData?.client.data?.id) {
                <dl class="p-2">
                  <dt>Client</dt>
                  <dd (click)="editField('client')" class="link-edit">
                    {{ addSiteFormData?.client.value }}
                  </dd>
                </dl>
              } @else {
                <div class="mb-2">
                  <div
                    [ngClass]="
                      addSiteFormData?.client?.tempValue
                        ? 'border border-danger rounded border-3'
                        : ''
                    "
                  >
                    <gtapp-auto-complete
                      [data]="clientDataList"
                      placeHolder="Client*"
                      searchKeyword="company_name"
                      [initialValue]="addSiteFormData.client.tempValue"
                      [itemTemplate]="ClientTemplate"
                      [addInitialKey]="true"
                      (inputChanged)="onClientSearch($event)"
                      (selected)="onClientSelect($event)"
                      [inputId]="'clientId'"
                      [enableCloseOption]="true"
                      (fieldCleared)="editField('client')"
                    >
                    </gtapp-auto-complete>
                  </div>
                  <ng-template #ClientTemplate let-item>
                    @if (item?.key === 0) {
                      <div>Add New Client</div>
                    } @else {
                      <div>
                        <div>{{ item?.company_name }}</div>
                        <div class="small-font text-secondary">
                          {{ item?.address?.full_address }}
                        </div>
                      </div>
                    }
                  </ng-template>
                </div>
              }
              <div class="col gap-2 d-flex align-items-center">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="auto_send_reports"
                  formControlName="auto_send_reports"
                />
                <label class="form-check-label" for="auto_send_reports">
                  Auto Send Reports</label
                >
              </div>
              @if (siteForm.value.auto_send_reports) {
                <div
                  class="m-1 p-2 small border border-1 rounded mb-3 text-danger"
                >
                  CAUTION: Reports (dockets) will be automatically sent out for
                  any job completed at this site.
                </div>
              }
            }

            <div class="small ms-2">
              <em>Fields marked with * cannot be empty</em>
            </div>
          </div>

          <div class="d-flex gap-2 pt-3">
            <button
              type="button"
              class="btn btn-dark btn-lg w-100"
              (click)="onCloseDialogue()"
            >
              Cancel
            </button>

            @if (siteExistsCheckData?.exact_site_exists) {
              <button
                type="submit"
                class="btn btn-danger btn-lg w-100"
                id="submitbtn1"
                (click)="addDuplicateSite()"
                [disabled]="!siteForm.valid"
              >
                Create Duplicate Site
              </button>
            } @else if (siteExistsCheckData?.site_address_data?.id) {
              <button
                type="submit"
                class="btn btn-primary btn-lg w-100"
                id="submitbtn1"
                (click)="confirmAndUpdateSite(confirmSiteUpdateChangeTemplate)"
                [disabled]="!siteForm.valid"
              >
                Next
              </button>
            } @else {
              <button
                type="submit"
                class="btn btn-success btn-lg w-100"
                id="submitbtn1"
                (click)="updateData()"
                [disabled]="!siteForm.valid"
              >
                Create New
              </button>
            }
          </div>
        </form>
      }
    </div>
  </div>
</div>

<ng-template
  #confirmSiteUpdateChangeTemplate
  let-confirmSiteUpdateChangeTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Site
      <span
        class="float-end"
        (click)="confirmSiteUpdateChangeTemplateRef.close(); detailData = null"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (siteExistsCheckData?.site_address_data?.current_name) {
      <div class="p-2">
        <div class="mb-2">
          You already have a site at this address, update the name of the site?
        </div>
        <div class="alert alert-success text-center">
          {{ siteExistsCheckData?.site_address_data?.current_name }}
          <span><i class="fa-solid fa-arrow-right"></i></span>
          <span class="fw-semibold">
            {{ siteExistsCheckData?.site_address_data?.new_name }}
          </span>
        </div>
      </div>
    }
    @if (
      siteExistsCheckData?.site_address_data?.current_location &&
      siteExistsCheckData?.site_address_data?.new_location
    ) {
      <div class="my-2">
        <div class="d-flex gap-2 align-items-center">
          <ng-container>
            <div class="flex-grow-1">
              <gtapp-map-leaflet
                [latLon]="
                  siteExistsCheckData?.site_address_data?.current_location
                "
                mapId="smallMapIdCurrent"
                [customMapConfig]="{ showSimpleStaticMap: true }"
              ></gtapp-map-leaflet>
            </div>
          </ng-container>

          <div>
            <i class="fa-solid fa-arrow-right"></i>
          </div>
          <ng-container>
            <div class="flex-grow-1">
              <gtapp-map-leaflet
                [latLon]="siteExistsCheckData?.site_address_data?.new_location"
                mapId="smallMapIdNew"
                [customMapConfig]="{ showSimpleStaticMap: true }"
              ></gtapp-map-leaflet>
            </div>
          </ng-container>
        </div>
      </div>
    }
    <div
      class="row mt-2"
      [ngClass]="
        siteExistsCheckData?.site_address_data?.current_name
          ? 'row-cols-3'
          : 'row-cols-2'
      "
    >
      <div class="col">
        <button
          class="btn btn-dark btn-lg btn-block w-100"
          (click)="
            detailData = null; confirmSiteUpdateChangeTemplateRef.close()
          "
        >
          Cancel
        </button>
      </div>
      @if (siteExistsCheckData?.site_address_data?.current_name) {
        <div class="col">
          <button
            [disabled]="!siteForm.valid"
            id="submitbtn"
            (click)="addUpdateSite()"
            class="btn btn-success btn-lg w-100"
          >
            Create New Site
          </button>
        </div>
      }
      <div class="col">
        <button
          [disabled]="!siteForm.valid"
          id="submitbtn"
          (click)="addUpdateSite(true)"
          class="btn btn-outline-success btn-lg w-100"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
